/**
 * Номера вида 79168663268 или +79168663268 превращает в +7 (916) 866-32-68. Учитывает, что может прийти неполный номер.
 */
export function formatPhoneForAnalytics(phone: string) {
  let formattedPhone = '+7';

  const matchResult = phone.match(/^(?:\+?7)?(\d{1,3})?(\d{1,3})?(\d{1,2})?(\d{1,2})?/);

  if (!matchResult) {
    return formattedPhone;
  }

  const groups = matchResult.slice(1);

  if (groups[0]) {
    const whitespacesCount = 3 - groups[0].length;

    formattedPhone += ` (${groups[0]}${' '.repeat(whitespacesCount)})`;
  }

  if (groups[1]) {
    formattedPhone += ` ${groups[1]}`;
  }

  if (groups[2]) {
    formattedPhone += `-${groups[2]}`;
  }

  if (groups[3]) {
    formattedPhone += `-${groups[3]}`;
  }

  return formattedPhone;
}
